import { z } from 'zod';
import { estimatingCurrencyCodeSchema, estimatingMoneyCentsSchema, } from './estimating-estimate.contract.js';
export const estimatingFinanceProfitabilityContractValuesCapability = 'estimating.finance-profitability-contract-values.v1';
export const estimatingFinanceProfitabilityContractValuesSlot = 'finance.project-profitability.contract-values';
export const estimatingFinanceProfitabilityContractValuesProviderId = 'estimating.server.finance-profitability-contract-values';
export const estimatingFinanceProfitabilityContractValuesRequestSchema = z.strictObject({
    consumerModuleId: z.literal('finance'),
    requestedCapability: z.literal('finance.project-profitability.v1'),
    resourceType: z.literal('finance.project-profitability'),
    resourceId: z.string().uuid(),
    projectIds: z.array(z.string().uuid()).min(1).max(500),
    maximumAcceptedEstimates: z.number().int().min(1).max(10_000),
}).superRefine((request, context) => {
    if (new Set(request.projectIds).size !== request.projectIds.length) {
        context.addIssue({
            code: 'custom',
            path: ['projectIds'],
            message: 'Profitability contract-value Projects cannot repeat.',
        });
    }
});
export const estimatingFinanceProfitabilityContractValueSchema = z.discriminatedUnion('state', [
    z.strictObject({
        state: z.literal('present'),
        projectId: z.string().uuid(),
        estimateId: z.string().uuid(),
        estimateVersionId: z.string().uuid(),
        estimateRevision: z.number().int().positive(),
        estimateContentHash: z.string().regex(/^[a-f0-9]{64}$/),
        acceptedAt: z.string().datetime({ offset: true }),
        currencyCode: estimatingCurrencyCodeSchema,
        contractValueCents: estimatingMoneyCentsSchema,
    }),
    z.strictObject({
        state: z.literal('missing'),
        projectId: z.string().uuid(),
        reasonCode: z.literal('no-accepted-estimate'),
    }),
    z.strictObject({
        state: z.literal('unavailable'),
        projectId: z.string().uuid(),
        reasonCode: z.literal('source-limit-exceeded'),
    }),
]);
export const estimatingFinanceProfitabilityContractValuesResponseSchema = z.strictObject({
    contractVersion: z.literal(estimatingFinanceProfitabilityContractValuesCapability),
    tenantId: z.string().uuid(),
    acceptedEstimateCount: z.number().int().nonnegative(),
    truncated: z.boolean(),
    projects: z.array(estimatingFinanceProfitabilityContractValueSchema).min(1).max(500),
}).superRefine((response, context) => {
    const ids = response.projects.map(({ projectId }) => projectId);
    if (new Set(ids).size !== ids.length) {
        context.addIssue({
            code: 'custom',
            path: ['projects'],
            message: 'Profitability contract values cannot repeat a Project.',
        });
    }
    if (response.truncated !== response.projects.some(({ state }) => state === 'unavailable')) {
        context.addIssue({
            code: 'custom',
            path: ['truncated'],
            message: 'Contract-value truncation must match unavailable source-limit facts.',
        });
    }
});
//# sourceMappingURL=estimating-finance-profitability-contract-values.contract.js.map